import type { EligibilityMeta } from "../types";

export const defaultEligibilityMeta: EligibilityMeta = Object.freeze({
    mdnLookupResult: {
        hasReachedMaxMdnLookups: false,
        previousHashedMdnLookups: [],
    },
});

export function normalizeEligibilityMeta(meta: EligibilityMeta | Partial<EligibilityMeta>): EligibilityMeta {
    try {
        const incoming: Partial<EligibilityMeta> = meta ?? {};
        const incomingMdnLookupResult = incoming.mdnLookupResult ?? defaultEligibilityMeta.mdnLookupResult;

        return {
            ...defaultEligibilityMeta,
            ...incoming,
            mdnLookupResult: {
                ...defaultEligibilityMeta.mdnLookupResult,
                ...incomingMdnLookupResult,
                previousHashedMdnLookups: Array.isArray(incomingMdnLookupResult.previousHashedMdnLookups)
                    ? incomingMdnLookupResult.previousHashedMdnLookups
                    : [],
            },
        };
    } catch (error) {
        console.warn("Failed to normalize eligibility meta", { error });
        return defaultEligibilityMeta;
    }
}
